import { useEffect } from 'react';
import { iniciarLogin } from '../services/auth.js';

export default function Login() {
  useEffect(() => {
    iniciarLogin();
  }, []);
  return <p aria-live="polite">Redirecionando para o login…</p>;
}
